






import { Vue, Component, Prop } from "@/shared/vuepack";
import EmployeeSearch from "@/shared/components/EmployeeSearch.vue";

@Component ({
    components: { EmployeeSearch }
})
export default class PartnerEmployeeSearch extends Vue {
  @Prop() partnerId: number;

  @Prop({required: false, default: null})
  routeToEmployeeCustomerService: (username: string) => Location;
}
